baseApp.service('SiteService', ['GeneralUtilsService', function(GeneralUtilsService) {
	var DEFAULT_BANDWIDTH = 100;
	var DEFAULT_MULTI_TUNNEL_MODE = "ACTIVE_PASSIVE";
	var DEFAULT_SITE_TYPE = "BRANCH";

    var siteService = {};

	var Site = function() {
		this.id = GeneralUtilsService.getRandomId();
		this.name = '';
		this.siteType = DEFAULT_SITE_TYPE;
		this.interfaces = [];
		this.socketConnectionConfiguration = {
		    multiTunnelMode: DEFAULT_MULTI_TUNNEL_MODE,
		};
		this.primaryBWUpstream = DEFAULT_BANDWIDTH;
		this.primaryBWDownstream =  DEFAULT_BANDWIDTH;
	}

    var fetchData = function(accountId, callback) {
        store.fetch({
            path: '/siteConnectionTypes',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback({
                    siteConnTypes: data,
                });
            }
        })
    }

    // if there is a lan link, need to make sure it will be linked at the back-end to the networkInterface.
    // This is happening at Site#assignSocketInterfaces.
    var mergeNetworkInterfaceForLANs = function(site) {
        var lanSocketInterfaces = [];
        if (site.socketConnectionConfiguration) {
            lanSocketInterfaces = _.filter(site.socketConnectionConfiguration.socketInterfaces, function(socketInterface) {
                    return siteService.isLanBasedSocketInterface(socketInterface.destType);
            });
        }

        let networkInterfaceMetaData = site?.interfaces?.filter(ni => ni.metadata !== null)[0]?.metadata;

        // this actually means that it is a socket connection type
        if (lanSocketInterfaces.length > 0) {
            var networkInterfacesToPreserve = [];

            // in this case we are moving from non-socket to a socket connection type because networkInterface.interface_id does not exist
            if (site.interfaces.length === 1 && !site.interfaces[0].interface_id) {
                site.interfaces = [site.interfaces[0]];
                site.interfaces[0].name = lanSocketInterfaces[0].name;
                site.interfaces[0].interface_id = lanSocketInterfaces[0].interface_id;
            } else {
                lanSocketInterfaces.forEach(function(lanSocketInterface) {
                    var found = false;
                    site.interfaces.forEach(function(networkInterface) {
                        // in case of site creation flow, id of both should be undefined -> equal
                        // in case of addOn selection flow, id of both should be equal because socket links were merged
                        // in case of moving from non-socket to a socket connection type -> networkInterface.interface_id will not exist
                        if (networkInterface.interface_id === lanSocketInterface.interface_id) {
                            networkInterfacesToPreserve.push(networkInterface);
                            found = true;
                        // in case of sockets migration flow, id of network interface still holds original while the socket interface was migrated
                        } else if (lanSocketInterface.originalInterface_id && networkInterface.interface_id === lanSocketInterface.originalInterface_id) {
                            networkInterface.interface_id = lanSocketInterface.interface_id;
                            networkInterfacesToPreserve.push(networkInterface);
                            found = true;
                        }
                    });

                    if (!found) {
                        networkInterfacesToPreserve.push(siteService.getNewNetworkInterface(lanSocketInterface, networkInterfaceMetaData));
                    }
                });

                site.interfaces = networkInterfacesToPreserve;
            }
        } else {
                site.interfaces = [siteService.getNewNetworkInterface(null, networkInterfaceMetaData)];
        }
    }

    var preserveLinks = function(site, socket) {
        var linksToCopy = socket.links.length > site.socketConnectionConfiguration.socketsSettings.primary.links.length ? site.socketConnectionConfiguration.socketsSettings.primary.links.length : socket.links.length;
        for (var i = 0; i < linksToCopy; i++) {
            if (socket.links[i].type === site.socketConnectionConfiguration.socketsSettings.primary.links[i].type) {
                socket.links[i] = site.socketConnectionConfiguration.socketsSettings.primary.links[i];
            }
        }
    }

    siteService.getNewNetworkInterface = function(socketInterface, metadata) {
        return {
            id: GeneralUtilsService.getRandomId(),
            type: 'NETWORKINTERFACE',
            interface_id: socketInterface ? socketInterface.interface_id : null,
            name: socketInterface ? socketInterface.name : 'Default',
            globalRange: {},
            subnets: [],
            hosts: [],
            metadata: metadata,
        };
    }

    siteService.getConnectionTypes = function(accountId, callback) {
    	fetchData(accountId, function(data) {
    	    callback(data);
    	});
    }

    siteService.getCatoSocketsData = function(accountId, siteId, siteConnType, addOnType, enableSecondaryWAN, socketConnectionConfiguration, callback) {
        var queryParams = {
            accountId: accountId,
            connectionType: siteConnType.value,
            enableSecondaryWAN: enableSecondaryWAN
        };

        if (addOnType)
            queryParams['addOnType'] = addOnType.value;
        if (siteId > 0)
            queryParams['siteId'] = siteId;

    	store.save({
            path: '/siteConnectionData',
            queryParams: queryParams,
            data: socketConnectionConfiguration,
            dataObj: socketConnectionConfiguration ? 'socketConnectionConfiguration' : null,
            success: function (data) {
                callback(data);
            }
        });
    }

	siteService.getNewSite = function() {
		return new Site();
	}

    siteService.siteHasSocketAddOn = function(site) {
        return site.siteConnType.socketModelTypeConfiguration &&
                site.siteConnType.socketModelTypeConfiguration.possibleAddOns &&
                site.siteConnType.socketModelTypeConfiguration.possibleAddOns.length > 0
    }

    //LAN_LAG_MEMBER is not included since they join the LAN_LAG_MASTER or LAN_LAG_MASTER_AND_VRRP settings
    siteService.isLanBasedSocketInterface = function(destType) {
        return destType.value === 'LAN' ||
               destType.value === 'VRRP_AND_LAN' ||
               destType.value === 'LAN_LAG_MASTER' ||
               destType.value === 'LAN_LAG_MASTER_AND_VRRP' ||
               destType.value === 'LAN_AND_HA';
    }

    siteService.mergeNewSiteSocketConnection = function(site, socketConnectionConfiguration) {
        site.socketConnectionConfiguration = socketConnectionConfiguration;
        if (site.siteConnType.socketModelTypeConfiguration) { // a socket site
            site.socketConnectionConfiguration.socketInterfaces = site.socketConnectionConfiguration.socketsSettings.primary.links;
        } else {
            site.socketConnectionConfiguration = null;
        }

        mergeNetworkInterfaceForLANs(site);

        if (siteService.siteHasSocketAddOn(site))
            site.socketAddOnType = site.socketConnectionConfiguration.socketsSettings.primary.addOn;
    }

	siteService.mergeSiteSocketConnection = function(site, socketConnectionConfiguration) {
        site.socketConnectionConfiguration = socketConnectionConfiguration;

        if (site.socketConnectionConfiguration) {
            if (site.siteConnType.socketModelTypeConfiguration) {
                site.socketConnectionConfiguration.socketInterfaces = site.socketConnectionConfiguration.socketsSettings.primary.links;
            } else {
                site.socketConnectionConfiguration.socketInterfaces = [];
            }
        }

        mergeNetworkInterfaceForLANs(site);
    }

    siteService.fixSiteSocketData = function(socketConnectionConfiguration) {
        if (!socketConnectionConfiguration)
            return;

        if (socketConnectionConfiguration.socketsSettings.primary) {
            socketConnectionConfiguration.socketInterfaces = socketConnectionConfiguration.socketsSettings.primary.links;
            socketConnectionConfiguration.socketsSettings.primary.links = [];
        }

        if (socketConnectionConfiguration.socketsSettings.secondary) {
            socketConnectionConfiguration.socketsSettings.secondary.links = [];
        }

        socketConnectionConfiguration.socketInterfaces.forEach(function(socketInterface) {
            // Need to provide random IDs in case new links were created in the back-end, the indication is that id property doesn't exists
            if (!socketInterface.id)
                socketInterface.id = GeneralUtilsService.getRandomId();

            if (!socketInterface.VLANTag)
                socketInterface.VLANTag = -1;

            if (!socketInterface.publicVLANTag)
                socketInterface.publicVLANTag = -1;
        })
    }

    return siteService;
}]);
